export default "__VITE_ASSET__BEbqTSGk__"